export const isRbacRole = (userRole) => {
  const rbacRoles = [
    'PLATFORM_SUPER_ADMIN',
    'PLATFORM_AGILE_ADMIN',
    'PLATFORM_AGILE_REGIONAL_LEAD',
    'PLATFORM_AGILE_ADVANCED_FLEXPERT_SUPPORT',
  ];

  return rbacRoles.includes(userRole);
};
